import { ROLLOVER_DATA_RECEIVED, ROLLOVER_DATA_UNLOADED } from './types';
import api from 'api';

export const rolloverDataUnload = () => ({
  type: ROLLOVER_DATA_UNLOADED
})

export const rolloverDataReceived = data => ({
  type: ROLLOVER_DATA_RECEIVED,
  data
})

export const unloadRollover = () => dispatch => {
  dispatch(rolloverDataUnload())
}

export const getRollover = () => (dispatch) =>
  api.bmc.rollover.getRollover().then(res => {
  dispatch(rolloverDataReceived(res))
});

export const processRollover = data => dispatch =>
  api.bmc.rollover.processRollover(data).then(res=>{
    dispatch(rolloverDataReceived(null))
  })
